// extracted by mini-css-extract-plugin
module.exports = {"Leading":"Leading_Leading__1EwGB"};